import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import "../../../components/styles/sidemenu.css";

const SideMenu = () => {
  const location = useLocation();

  const programs = [
    {
      id: "overview",
      paths: ["/sustainability-overview"],
      label: "Overview"
    },
    {
      id: "SDG",
      paths: ["/SDG-contributions"],
      label: "SDG Contributions"
    },
    {
      id: "policy",
      path: "https://adityauniversity.in/adtppu/SDG/policy.pdf",
      label: "Policy"
    },
    {
      id: "report",
      paths: ["/SDG-reports"],
      label: "SDG Reports"
    }
  ];

  return (
    <div className="container">
      <div className="programs">
        {programs.map((program) => {
          const isActive = program.paths?.includes(location.pathname);

          return (
            <div
              className={`program ${isActive ? "active" : ""}`}
              key={program.id}
            >
              {/* If external PDF */}
              {program.path ? (
                <a
                  href={program.path}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <label htmlFor={program.id}>{program.label}</label>
                </a>
              ) : (
                // Internal navigation
                <NavLink
                  to={program.paths[0]}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <input
                    type="radio"
                    id={program.id}
                    name="program"
                    readOnly
                    checked={isActive}
                  />
                  <label htmlFor={program.id}>{program.label}</label>
                </NavLink>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SideMenu;
